import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-creator',
  templateUrl: './user-creator.component.html',
  styleUrls: ['./user-creator.component.scss']
})
export class UserCreatorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
